export const reducer = (state, action) => {
  switch (action.type) {
    default:
      return { ...action };
  }
};

export const initialState = {
  active: false,
};
